import AdminResellerFormModule from '@/modules/admin-reseller-form';

const AdminResellerForm = () => {
  return <AdminResellerFormModule />;
};

export default AdminResellerForm;
